// // Example starter JavaScript for disabling form submissions if there are invalid fields
// import { Constants } from "../ENVIROMENT_VARIABLES";

// (function () {
//     const form = document.getElementById('contact_form');

//     $(form).find('.loading-spinner').hide();
//     $(form).find('.error-message').removeClass('active');
//     $(form).find('.success-message').removeClass('active');

//     form.addEventListener('submit', function (event) {
//         $(form).find('.loading-spinner').hide();
//         $(form).find('.error-message').removeClass('active');
//         $(form).find('.success-message').removeClass('active');
//         if (!form.checkValidity()) {
//             event.preventDefault();
//             event.stopPropagation();
//         }else{
//             event.preventDefault();
//             SubmitContactForm(event.currentTarget);
//         }
//         $(form).addClass('was-validated');
//     }, false)

// })();



// function SubmitContactForm(contactForm) {
//    const selectedIndex = $(contactForm).find('#contact_reason').prop('selectedIndex').toString();
//    const feedback = JSON.stringify({
//         Name: $(contactForm).find('#contact_name').val(),
//         PhoneNumber: $(contactForm).find('#contact_phone').val(),
//         Type: selectedIndex,
//         Message: $(contactForm).find('#contact_message').val()    
//    });
//    $.ajax({
//        url:Constants.BASE_URL+'api/FeedBack/Submit',
//        method: 'POST',
//        contentType: 'application/json',
//        beforeSend: ()=>
//        {
//             $(contactForm).find('.loading-spinner').fadeIn();
//             $('#contact-btn').attr('disabled', true);
//        },
//        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
//        data: feedback,
//        success: (response) => {
//             //console.log(response);
//             $(contactForm).find('.loading-spinner').fadeOut();
//             $('#contact-btn').attr('disabled', false);
//             $(contactForm).find('.success-message').addClass('active');
//             setTimeout( () => {
//                 $(contactForm).find('.success-message').removeClass('active');
//              }, 5000);
//        },error: (err) => {
//             //console.log(err);
//             $(contactForm).find('.loading-spinner').fadeOut();
//             $('#contact-btn').attr('disabled', false);
//             $(contactForm).find('.error-message').addClass('active');
//             setTimeout( () => {
//                 $(contactForm).find('.error-message').removeClass('active');
//              }, 5000);
//        }

//    }).done(()=> {
//         setTimeout(() => {
//             $(contactForm).removeClass('was-validated');
//             contactForm.reset();
//         }, 0);
//    });
// } 


import 'jquery/dist/jquery.min';
import 'jquery-validation/dist/jquery.validate.min';
import 'jquery-validation/dist/additional-methods.min';
import jquery from 'jquery';

const contact_form = $('#contact_form');
contact_form.validate({
    errorClass: "invalid",
    validClass: "valid",
    // errorElement: "em",
    rules: {
        contact_name: {
            required: true,
        },
        contact_phone: {
            required: true,
            // phoneNumberFormat: true

        },
        contact_reason: {
            required: true,
        },
        contact_message: {
            required: true,
        },

    },
    onfocusout: function (element) {
        this.element(element); // triggers validation
    },
    onkeyup: function (element, event) {
        this.element(element); // triggers validation
    },
    messages: {
        contact_name: {
            required: "Please enter the name",
        },
        contact_phone: {
            required: "Phone is required",
        },
        contact_reason: {
            required: "Reason is required",
        },
        contact_message: {
            required: "Message is required",
        },

    },
    errorElement: "em",
    errorPlacement: function (error, element) {
        // Add the `help-block` class to the error element
        error.addClass("alert alert-danger d-flex align-items-center mt-2");

        // Add `has-feedback` class to the parent div.form-group
        // in order to add icons to inputs
        element.parents(".input-field").addClass("is-invalid");

        if (element.prop("type") === "checkbox") {
            error.insertAfter(element.parent("label"));
        } else {
            error.insertAfter(element);
        }
    },
    success: function (label, element) {
        // //console.log('success');
        //hide error alert
        $(element).addClass("is-valid").removeClass("-invalid");
        $(element).siblings('em').removeClass("alert alert-danger d-flex align-items-center mt-2");
    },
    highlight: function (element, errorClass, validClass) {
        $(element).addClass("is-invalid").removeClass("is-valid");
        // $( element ).next( "span" ).addClass( "is-valid" ).removeClass( "is-invalid" );
        $(element).siblings('em').addClass("alert alert-danger d-flex align-items-center mt-2");

    },
    unhighlight: function (element, errorClass, validClass) {
        $(element).addClass("is-valid").removeClass("is-invalid");
        $(element).siblings('em').removeClass("alert alert-danger d-flex align-items-center mt-2");

    }

});
// jquery.validator.addMethod("phoneNumberFormat", function (value, element) {
//     return this.optional(element) || /^[(00)|(+)]{1}[0-9\\s.\\/-]{6,20}$/.test(value);
// }, "Please Enter Valid Format for Phone Number");


// Add fixed country code prefix in phone number input fields
var input = document.querySelector('input[data-fixedvalue]');
    input.addEventListener("keyup", function (e) {
        if (input.value.length < 5) {
            input.value = '00966';
        }
    });